import "../scss/style.scss"

import * as Popper from "@popperjs/core"
import { Collapse } from 'bootstrap';
import Modal from 'bootstrap'
import Blazy from 'blazy'

import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';

import {settings} from './variables.js';

var baseUrl = settings.apiBaseUrl;

window.Swiper = Swiper;
window.SwiperPagination = Pagination;
window.SwiperNavigation = Navigation;


require('./actions.js')
require('./cases-slider.js')

require('./main_vue.js')

;(function() {
    var bLazy = new Blazy()
})()

// getDropdowns()
// getCollapses()
